import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteAlmamaterVisitCategory = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const { oid, name } = props.data

  const handleOk = () => {
    axios.post('/p/almamater_visit/category/delete', { 
      merchant_oid: merchantOid, 
      category_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除分类成功！')
          props.isCancel()
          props.getAlmamaterVisitCategoryList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除母校行分类"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将分类
        <span style={{color: '#005dff'}}>《{name}》</span>
        从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteAlmamaterVisitCategory
